export default "__VITE_ASSET__CB8baC6l__"